import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import 'swiper/dist/css/swiper.css'
import swiper from '@/components/swiper/swiper'
import JsBridge from './utils/jsbridge'
const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr')
const infiniteScroll = require('vue-infinite-scroll')
import pkg from "./../package.json"

Vue.use(VueAwesomeSwiper)
Vue.use(infiniteScroll)
Vue.component(swiper.name, swiper)
Vue.config.productionTip = false
Vue.use(JsBridge, {
  callback: bridge => {
    window.zm1v1jsBridge = bridge
  }
})

if (
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'testing'
) {
  const { ZMSDK } = window;
  if (ZMSDK) {
    ZMSDK.topic = 'h5sdk_test'
  }
}


const { ZM_JSSDK } = window;
let env = "prod";
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
  env = "fat";
} else if (process.env.NODE_ENV === 'uat') {
  env = "uat";
}
if (ZM_JSSDK) {
  // 配置sdk参数
  ZM_JSSDK.setConfig({
    environment: env,
    // 如果你使用了router并且是history模式
    // 如果你使用了vue-router的hash模式，也是设置history
    history: true,
    interceptor: false,
    urlParams: true,
  });

  // 配置上报公共属性
  ZM_JSSDK.setDefaults({
    appId: '10168',
    appVersion: pkg.version,
    deviceId: localStorage.getItem('ZM_DEVICEID')
    // 其他公共字段，appId & appVersion请尽量参考**使用须知**
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
